import { FunctionComponent } from "react";
import { format, isSameDay } from "date-fns";

import { ListPerson } from "../../../List/schema/list";

/**
 * Date separator shown above the first Inbox lead of each day (leads are grouped
 * by `lastConversationAt`). Renders nothing when the previous lead shares the same
 * day, or when the current lead has no conversation date.
 */
export const InboxDateDivider: FunctionComponent<{
	current: ListPerson;
	previous?: ListPerson;
}> = ({ current, previous }) => {
	if (!current?.lastConversationAt) {
		return null;
	}

	const previousAt = previous?.lastConversationAt;

	if (previousAt && isSameDay(new Date(previousAt), new Date(current.lastConversationAt))) {
		return null;
	}

	return (
		<div className="w-full text-text-status-info text-sm p-2 font-bold bg-status-info-light border border-border-light justify-center items-center text-left">
			{format(new Date(current.lastConversationAt), "MMMM dd, yyyy")}
		</div>
	);
};
